export const getDynamicPageId = (pageId: string) =>
  pageId.replace(/_[^_]*$/, '')
